export const css = {
    root: '_2v5XlEy_',
    content: 'zEqeu7XC',
    bottom: '_1aPRzT85',
    top: '_2CBRR1tL',
    left: '_2Bgy_VqU',
    right: '_28wQ1cXq',
    ' _key': 'certwise-theme/certwise/dojo/tooltip'
};
export default css;
